import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Box,
  Stack,
  Chip,
} from "@mui/material";

const DynamicPageLayout = ({ pageContentJson, data }: any) => {
  return (
    <>
      {pageContentJson?.map(
        (
          card: {
            chip: any;
            caption: any;
            title: any;
            description: any;
            noCard: boolean;
            content: any[];
          },
          index: any
        ) => {
          const Cmp = ({ children }: any) =>
            card?.noCard ? <>{children}</> : <Card>{children}</Card>;
          return (
            <Cmp key={index}>
              <Box className="pageContent">
                <CardContent>
                  {card.title && (
                    <Box className="mt1 mb3">
                      <Stack direction="row" columnGap={1}>
                        <Typography variant="h5" component="div">
                          {card.title}
                        </Typography>
                        {card.chip && (
                          <Chip
                            label={card.chip}
                            variant="outlined"
                            color="info"
                          />
                        )}
                      </Stack>
                      {card?.caption && (
                        <Typography variant="body2" color="text.secondary">
                          {card?.caption}
                        </Typography>
                      )}
                    </Box>
                  )}
                  {card.description && (
                    <>
                      <Typography variant="body1" display="block">
                        {card.description}
                      </Typography>
                      <br />
                    </>
                  )}

                  <Grid container spacing={2} className="pageContent">
                    {card?.content?.map((cardContent, index) => {
                      return (
                        <>
                          <Grid
                            key={index}
                            item
                            md={
                              (!isNaN(cardContent?.size) &&
                                cardContent?.size) ||
                              cardContent?.size?.mediumScreen
                            }
                            sm={
                              (!isNaN(cardContent?.size) &&
                                cardContent?.size) ||
                              cardContent?.size?.smallScreen ||
                              cardContent?.size?.mediumScreen
                            }
                            xs={
                              (!isNaN(cardContent?.size) &&
                                cardContent?.size) ||
                              cardContent?.size?.extraSmallScreen ||
                              cardContent?.size?.mediumScreen
                            }
                          >
                            <Typography variant="caption" display="block">
                              {cardContent?.label}
                            </Typography>
                            <Typography
                              variant="body1"
                              gutterBottom
                              className="wordWrap"
                            >
                              {!cardContent?.isDivider &&
                                (data[cardContent?.key] ||
                                  cardContent?.value ||
                                  "-")}
                            </Typography>
                          </Grid>
                          {cardContent?.isDivider && (
                            <Divider orientation="vertical" flexItem />
                          )}
                        </>
                      );
                    })}
                  </Grid>
                </CardContent>
              </Box>
            </Cmp>
          );
        }
      )}
    </>
  );
};

export default DynamicPageLayout;
